import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Flex } from '@chakra-ui/react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import TrialStatusBanner from './TrialStatusBanner';
import TourModeBanner from '../organization/TourModeBanner';
import { useUser } from '../../contexts/UserContext';

const Dashboard = () => {
  const { user } = useUser();
  const organization = user?.organization;
  const isTourMode = organization?.tour_mode === true;

  return (
    <Flex>
      {/* Sidebar */}
      <Box display={{ base: 'none', md: 'block' }}>
        <Sidebar />
      </Box>

      {/* Main Content */}
      <Box ml={{ base: 0, md: '250px' }} width="100%">
        <Navbar />
        <TourModeBanner isTourMode={isTourMode} organization={organization} />
        <TrialStatusBanner />

        {/* Content Area */}
        <Box p={4} className="content-box">
          <Outlet /> {/* This will render the nested routes */}
        </Box>
      </Box>
    </Flex>
  );
};

export default Dashboard;
